import { ButtonBase, Grid, IconButton, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import "./css/mainpage.css";
import ButtonReusable from "../../components/buttons/ButtonReusable";
import amclogo from "../../assets/amclogo.png";

import banner from "../../assets/banner.jpg";
import secondBanner from "../../assets/bg2.webp";
import construction from "../../assets/construction.png";
import maintenance from "../../assets/lanscape.png";
import design from "../../assets/interior.png";
import consultation from "../../assets/consultation.png";
import estimate from "../../assets/estimate.png";
import blueprint from "../../assets/blueprint.webp";
import plan from "../../assets/plan2.jpg";
import plan3 from "../../assets/plan3.webp";
import darkbg from "../../assets/darkbg.webp";

import { FaCircleArrowRight } from "react-icons/fa6";
import { FiArrowRightCircle } from "react-icons/fi";
import { BsArrowRightCircle } from "react-icons/bs";
import { TfiArrowCircleRight } from "react-icons/tfi";
import { MdOutlineArrowOutward } from "react-icons/md";
import { TbArrowUpRight } from "react-icons/tb";
import { FaPhoneAlt } from "react-icons/fa";
import { BsDashLg } from "react-icons/bs";
import proj1 from "../../assets/proj/proj1.jpg";
import proj2 from "../../assets/proj/proj2.jpg";
import proj3 from "../../assets/proj/proj3.jpg";
import proj4 from "../../assets/proj/proj4.jpg";

// reusable components
import ServicesCard from "../../components/cards/ServicesCard";

// utils
import { cardDetails } from "../../components/utils/CardUtils";
import DialogReusable from "../../components/dialog/DialogReusable";
import { useNavigate } from "react-router-dom";
import MainpageHook from "./hooks/MainpageHook";
import Loading from "../../components/loading/Loading";

const MainPage = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { ...param } = MainpageHook();

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Grid container spacing={2}>
            <div className="main-banner">
              <Grid item xs={12} md={12}>
                <div className="banner-image-container">
                  <img src={banner} alt="main banner" />
                  <img
                    src={secondBanner}
                    alt="second banner"
                    className="banner-img"
                  />
                </div>
                <div className="main-dark-overlay">
                  <div className="main-hero-text">
                    <h1>Building your dreams from ground up</h1>
                    <p>Design, Estimate, Plan, Construct</p>
                    {/* <div className="contact-container">
                      <FaPhoneAlt className="contact-icon" />{" "}
                      <p id="contact">09190792240</p>
                    </div> */}
                  </div>

                  <div className="second-banner">
                    {/* <img src={secondBanner} alt="second banner" /> */}
                    <div className="content-wrapper">
                      <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12} md={10}>
                          <div className="content-container">
                            <Grid container spacing={2}>
                              <Grid item xs={12} md={6}>
                                <div className="left-content">
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                      <div className="we-do">
                                        <div className="img-wapper">
                                          <div className="left-img-container">
                                            <img
                                              src={design}
                                              alt=""
                                              className="main-icon"
                                            />
                                          </div>
                                        </div>

                                        <div className="title">
                                          <h3>Construction Management</h3>
                                          <p>
                                            Independent building construnction
                                            and home improvement services
                                          </p>
                                        </div>
                                        <div className="more-icon-container">
                                          <div className="btn-wrapper">
                                            <IconButton>
                                              <BsArrowRightCircle className="icon" />
                                            </IconButton>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <div className="we-do">
                                        <div className="img-wapper">
                                          <div className="left-img-container">
                                            <img
                                              src={maintenance}
                                              alt=""
                                              className="main-icon"
                                            />
                                          </div>
                                        </div>

                                        <div className="title">
                                          <h3>Maintenance & Repair</h3>
                                          <p>
                                            Elevating Systems through Expert
                                            Maintenance and Swift Repairs!
                                          </p>
                                        </div>
                                        <div className="more-icon-container">
                                          <div className="btn-wrapper">
                                            <IconButton>
                                              <BsArrowRightCircle className="icon" />
                                            </IconButton>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <div className="we-do">
                                        <div className="img-wapper">
                                          <div className="left-img-container">
                                            <img
                                              src={estimate}
                                              alt=""
                                              className="main-icon"
                                            />
                                          </div>
                                        </div>

                                        <div className="title">
                                          <h3>Design, Planning, Estimate</h3>
                                          <p>
                                            Crafting Tomorrow: Unleashing
                                            Innovation Through Seamless Design,
                                            Meticulous Planning, and Precise
                                            Estimation!
                                          </p>
                                        </div>
                                        <div className="more-icon-container">
                                          <div className="btn-wrapper">
                                            <IconButton>
                                              {/* <FaCircleArrowRight className="icon" /> */}
                                              {/* <FiArrowRightCircle className="icon" /> */}
                                              <BsArrowRightCircle className="icon" />
                                              {/* <TfiArrowCircleRight className="icon" /> */}
                                            </IconButton>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <div className="we-do">
                                        <div className="img-wapper">
                                          <div className="left-img-container">
                                            <img
                                              src={consultation}
                                              alt=""
                                              className="main-icon"
                                            />
                                          </div>
                                        </div>

                                        <div className="title">
                                          <h3>Project Consultation</h3>
                                          <p>
                                            Beyond Blueprints: Orchestrating
                                            Success with Project Management
                                            Mastery and Strategic Consultation
                                            Expertise!
                                          </p>
                                        </div>
                                        <div className="more-icon-container">
                                          <div className="btn-wrapper">
                                            <IconButton>
                                              {/* <FaCircleArrowRight className="icon" /> */}
                                              {/* <FiArrowRightCircle className="icon" /> */}
                                              <BsArrowRightCircle className="icon" />
                                              {/* <TfiArrowCircleRight className="icon" /> */}
                                            </IconButton>
                                          </div>
                                        </div>
                                      </div>
                                    </Grid>
                                  </Grid>
                                </div>
                              </Grid>
                              <Grid item xs={12} md={6}>
                                <div className="right-content">
                                  <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                      <p>WHAT WE OFFER</p>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                      <h2>
                                        Providing solutions for construction,
                                        management, and restoration.
                                      </h2>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                      <p className="p-long">
                                        Unlocking Potential: Delivering
                                        Comprehensive Solutions for
                                        Construction, Management, and
                                        Restoration Needs. From groundbreaking
                                        to project completion, our expertise in
                                        construction ensures seamless execution.
                                        With strategic management, we optimize
                                        resources, timelines, and budgets for
                                        unparalleled project success.
                                        Additionally, our restoration services
                                        breathe new life into existing
                                        structures, preserving heritage and
                                        enhancing functionality. At the core of
                                        our mission is a commitment to providing
                                        innovative solutions that redefine the
                                        landscape of construction, management,
                                        and restoration industries.
                                      </p>
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                      <div
                                        className="view-more-container"
                                        onClick={() =>
                                          param.handleLoading("/contact")
                                        }
                                      >
                                        <p>View more</p>
                                        <MdOutlineArrowOutward />
                                      </div>
                                      {/* {param.loading ? <Loading /> : null} */}
                                    </Grid>
                                  </Grid>
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </div>
              </Grid>
            </div>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} md={10}>
              <div className="profile-container">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <div className="company-profile">
                          <p>Our Company</p>
                          <h1>Company Profile</h1>
                          <p>
                            AMC Construction Corporation traces its roots back
                            to 1980 when it operated as Cruzant Engineering
                            under the leadership of founder chairman Engr.
                            Antonio M. Cruz, PME. In 2022, the company
                            transitioned into a corporation, officially becoming
                            AMC Construction Corporation. With a solid
                            foundation in Cruzant Engineering, our journey has
                            evolved into a reputable corporation specializing in
                            delivering high-quality construction services.{" "}
                            <br /> <br />
                            Since our inception, we've prioritized excellence,
                            consistently completing projects on time and within
                            budget. Our dedicated team of professionals
                            possesses extensive experience in a diverse range of
                            construction, renovation, and remodeling services.
                            At AMC Construction Corporation, safety stands as
                            our paramount concern, ensuring strict adherence to
                            industry safety standards throughout every project.{" "}
                            <br />
                            <br />
                            Our commitment to client satisfaction has solidified
                            our standing, garnering a strong reputation with
                            each undertaking. As we look toward the future, AMC
                            Construction Corporation remains dedicated to
                            upholding the values of quality, safety, and client
                            contentment in every endeavor we pursue.
                          </p>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <div
                          className="view-more-container"
                          onClick={() =>
                            param.handleLoading("/company_profile")
                          }
                        >
                          <p>View more</p>
                          <MdOutlineArrowOutward />
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="right-container">
                      <div className="blueprint-container">
                        <img src={plan3} alt="" />
                        <img src={blueprint} alt="" />
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12}>
          <div className="dark-bg-container">
            <div className="dark-img-container">
              <img src={darkbg} alt="" className="section-img" />
              <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12} md={11}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      <div className="dashed-header">
                        <BsDashLg />
                        <p>Latest Project</p>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className="section-title">
                        <p>Check Out Our Newest Projects</p>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12} md={12}>
                  <div className="proj-wrapper">
                    <div className="proj-img-container">
                      <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={12} md={11}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                              <div className="proj-img-holder">
                                <img src={proj1} alt="" />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <div className="proj-img-holder">
                                <img src={proj2} alt="" />
                              </div>
                            </Grid>{" "}
                            <Grid item xs={12} md={3}>
                              <div className="proj-img-holder">
                                <img src={proj3} alt="" />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <div className="proj-img-holder">
                                <img src={proj4} alt="" />
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} md={12}>
          <div className="featured-services-container">
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <div className="fs-text-content">
                      <p>FEATURED SERVICES</p>
                      <h1>Featured Services</h1>
                      <p>
                        Our featured services offer a comprehensive approach to
                        the entire lifecycle of a project, starting with
                        pre-construction planning where we meticulously analyze
                        and strategize to optimize your project's success.
                      </p>
                    </div>
                  </Grid>
                  {cardDetails.map((card, index) => (
                    <Grid item xs={12} md={3} key={index}>
                      <div className="card-container">
                        <ServicesCard icon={card.icon} title={card.title} />
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </Grid>

        {/* footer section */}
        <Grid item xs={12} md={12}></Grid>
      </Grid>
    </div>
  );
};

export default MainPage;
